// Create Corporate Plan
export const CREATE_CORPORATE = "CREATE_CORPORATE";
export const CREATE_CORPORATE_SUCCESS = "CREATE_CORPORATE_SUCCESS";
export const CREATE_CORPORATE_ERROR = "CREATE_CORPORATE_ERROR";

// List All Corporate Plan
export const CREATE_CORPORATE_ALL = "CREATE_CORPORATE_ALL";
export const CREATE_CORPORATE_ALL_SUCCESS = "CREATE_CORPORATE_ALL_SUCCESS";
export const CREATE_CORPORATE_ALL_ERROR = "CREATE_CORPORATE_ALL_ERROR";

// Delete Corporate Plan
export const DELETE_CORPORATE = "DELETE_CORPORATE";
export const DELETE_CORPORATE_SUCCESS = "DELETE_CORPORATE_SUCCESS";
export const DELETE_CORPORATE_ERROR = "DELETE_CORPORATE_ERROR";

// EDIT Corporate Plan
export const EDIT_CORPORATE_PLAN = "EDIT_CORPORATE_PLAN";
export const EDIT_CORPORATE_PLAN_SUCCESS = "EDIT_CORPORATE_PLAN_SUCCESS";
export const EDIT_CORPORATE_PLAN_ERROR = "EDIT_CORPORATE_PLAN_ERROR";

// Update Corporate Plan
export const UPDATE_CORPORATE_PLAN = "UPDATE_CORPORATE_PLAN";
export const UPDATE_CORPORATE_PLAN_SUCCESS = "UPDATE_CORPORATE_PLAN_SUCCESS";
export const UPDATE_CORPORATE_PLAN_ERROR = "UPDATE_CORPORATE_PLAN_ERROR";